export const isCromi = () => {
    const config = useRuntimeConfig()

    return config.public.website === 'cromi.ru'
}
